import $api from "../http";

import { ICancelOpenGymReservation, ICreateOpenGymReservation, IOpenGym } from "../models/OpenGym";

class OpenGymServiceClass {
  async createOpenGymReservation(model: ICreateOpenGymReservation) {
    return await $api.post<{}>(`api/open-gym/reservation/create`, {
      ...model,
    });
  }

  async cancelOpenGymReservation(model: ICancelOpenGymReservation) {
    return await $api.delete(`api/open-gym/reservation/cancel/${model.reservationId}`, {
      data: { gymListingId: model.gymListingId },
    });
  }

  async getOpenGymsByDateAndGymId(gymId: string, date?: string, userId?: string) {
    let mainUrl = `api/open-gym/all-by-gym-and-date/${gymId}?date=${date}`;

    if (userId) {
      mainUrl += `&userId=${userId}`;
    }

    return await $api.get<IOpenGym[]>(mainUrl);
  }
}

export const OpenGymService = new OpenGymServiceClass();
